/**
 * toggleActiveForPurchase — extraído de ForecastPage.tsx (P7 split).
 *
 * Toggle activeForPurchase con UX optimista:
 *   1) Flip in-memory inmediato.
 *   2) PATCH /forecasting/product-mapping/:id/active-for-purchase con {} (server-side toggle).
 *   3) Sincroniza con valor del servidor; si error → revierte.
 *   4) Si el resultado es false, deselecciona el id si estaba seleccionado.
 */

import { apiClient } from "@/services/apiClient";
import { ProductData } from "./types";

interface ToggleActiveForPurchaseOptions {
  unifiedProductId: string;
  setProducts: (
    updater: (prev: ProductData[]) => ProductData[],
  ) => void;
  setSelectedIds: (
    updater: (prev: Set<string>) => Set<string>,
  ) => void;
}

export async function toggleActiveForPurchase(
  opts: ToggleActiveForPurchaseOptions,
): Promise<void> {
  const { unifiedProductId, setProducts, setSelectedIds } = opts;

  // Optimistic toggle
  setProducts((prev) =>
    prev.map((p) =>
      p.unifiedProductId === unifiedProductId
        ? { ...p, activeForPurchase: !(p.activeForPurchase ?? false) }
        : p,
    ),
  );

  try {
    const res = await apiClient.patch(
      `/forecasting/product-mapping/${encodeURIComponent(unifiedProductId)}/active-for-purchase`,
      {},
    );
    const json = res.data as { data?: { activeForPurchase?: boolean } };
    const next = !!json?.data?.activeForPurchase;
    setProducts((prev) =>
      prev.map((p) =>
        p.unifiedProductId === unifiedProductId
          ? { ...p, activeForPurchase: next }
          : p,
      ),
    );
    if (!next) {
      setSelectedIds((prev) => {
        if (!prev.has(unifiedProductId)) return prev;
        const nextSet = new Set(prev);
        nextSet.delete(unifiedProductId);
        return nextSet;
      });
    }
  } catch (e) {
    console.error("Failed to toggle active_for_purchase", e);
    // Revert on error
    setProducts((prev) =>
      prev.map((p) =>
        p.unifiedProductId === unifiedProductId
          ? { ...p, activeForPurchase: !(p.activeForPurchase ?? false) }
          : p,
      ),
    );
  }
}
